import React from 'react';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import Api_Config from '../../code/api/ApiConfig';
import Auth from "../../code/auth/Auth";
import BidPeriodAwardReportInfo from "../../code/models/BidPeriodAwardReportInfo";
import '../../css/adminbidpacklist.css';

interface IAdminAwardReportList {
    awardReports: BidPeriodAwardReportInfo[]
}

export default function AdminAwardReportList({ awardReports }: IAdminAwardReportList) {
    const bplColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "base",
            title: "Base",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "aircraftGroup",
            title: "Aircraft",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "position",
            title: "Seat",
            visible: true,
            formatData: formatSeat,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "updateDate",
            title: "Updated",
            visible: true,
            formatData: formatDate,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "bidPeriodFileId",
            title: "",
            visible: true,
            formatData: buildViewDocumentColumn,
            type: CclDataTableColumnType.Data
        }
    ];

    var comp = Api_Config.getSelectedCompany();

    function formatSeat(val: any, rowData: any) {
        return (!val || val.trim() === "") ? "???" : val;
    }

    function buildViewDocumentColumn(val: any, rowData: any) {
        let buttonClasses = "btn btn-primary btn-sm";
        let token = Auth.getAuthToken();
        return (
            <a className={buttonClasses} href={`${comp.adminApiUrl}/document/doc/${rowData.bidPeriodFileId}?t=${token}`} target="_blank">View</a>
        )
    }

    function formatDate(val: Date) {
        let sval = ("" + val).replace("T", " ");
        val = new Date(sval);
        let dateStr = val.toISOString().split('T')[0];
        let time = new Intl.DateTimeFormat('en-us', { hour: '2-digit', minute: '2-digit', hour12: true }).format(val);
        return `${dateStr} ${time}`;
    }

    return (
        <React.Fragment>
            <div className="bidpack-table-wrapper">
                <CclDataTable
                    name={"profilesTable"}
                    tableData={awardReports || []}
                    columnDefinitions={bplColumnDefs}
                    onRowSelect={null}
                    rowSelect={false}
                    onButtonClick={null} />
            </div>
        </React.Fragment >
    )
}

